var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinnericon = function SvgSpinnericon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M24 5.5v7m0 23v7M5.5 24.001h7m23 0h7M10.919 10.918l4.95 4.95m16.263 16.263 4.95 4.95m-26.162.002 4.95-4.95m16.263-16.264 4.95-4.95"
  })));
};
export default SvgSpinnericon;